import { useEffect, useRef, useState } from "react";
import { subscribeTicks, setAppId } from "@/lib/deriv";
import { useConfig } from "@/hooks/useConfig";

const TICKER_SYMBOLS = [
  // v8.5 FOREX-PIVOT — landing page ticker now features the live universe.
  { sym: "frxEURUSD", label: "EUR/USD" },
  { sym: "frxGBPUSD", label: "GBP/USD" },
  { sym: "frxUSDJPY", label: "USD/JPY" },
  { sym: "frxAUDUSD", label: "AUD/USD" },
  { sym: "frxUSDCAD", label: "USD/CAD" },
  { sym: "frxNZDUSD", label: "NZD/USD" },
  { sym: "frxXAUUSD", label: "Gold" },
  { sym: "frxXAGUSD", label: "Silver" },
  { sym: "cryBTCUSD", label: "BTC/USD" },
  { sym: "cryETHUSD", label: "ETH/USD" },
  { sym: "frxEURJPY", label: "EUR/JPY" },
  { sym: "frxGBPJPY", label: "GBP/JPY" },
];

const LiveTicker = () => {
  const { config } = useConfig();
  const [prices, setPrices] = useState({});
  const unsubsRef = useRef([]);

  useEffect(() => {
    if (!config) return;
    setAppId(config.deriv_app_id);

    TICKER_SYMBOLS.forEach(({ sym }) => {
      const unsub = subscribeTicks(sym, (data) => {
        if (!data?.tick) return;
        setPrices((prev) => {
          const last = prev[sym]?.price;
          return {
            ...prev,
            [sym]: { price: data.tick.quote, prev: last, ts: data.tick.epoch },
          };
        });
      });
      unsubsRef.current.push(unsub);
    });

    return () => {
      unsubsRef.current.forEach((u) => u && u());
      unsubsRef.current = [];
    };
  }, [config]);

  const items = [...TICKER_SYMBOLS, ...TICKER_SYMBOLS];

  return (
    <div
      data-testid="live-ticker-bar"
      className="relative border-y border-vts-line bg-vts-surface/70 backdrop-blur-sm overflow-hidden"
    >
      <div className="ticker-mask overflow-hidden">
        <div className="flex animate-ticker-scroll whitespace-nowrap py-3">
          {items.map(({ sym, label }, idx) => {
            const p = prices[sym];
            const change = p?.prev != null && p.price != null ? p.price - p.prev : 0;
            const color =
              change > 0 ? "text-vts-profit" : change < 0 ? "text-vts-loss" : "text-vts-silver";
            return (
              <div
                key={`${sym}-${idx}`}
                className="inline-flex items-center gap-3 px-6 border-r border-vts-line/50 shrink-0"
              >
                <span className="text-xs font-medium uppercase tracking-wider text-vts-silver/70">
                  {label}
                </span>
                <span className={`font-mono text-sm font-medium tabular-nums ${color}`}>
                  {p?.price != null ? p.price.toFixed(p.price < 10 ? 4 : 2) : "—"}
                </span>
                {change !== 0 && (
                  <span className={`text-[10px] font-mono ${color}`}>
                    {change > 0 ? "▲" : "▼"}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LiveTicker;
